export {
  default,
  defaultSuccessLogger,
  defaultErrorLogger,
  setSuccessLogger,
  setErrorLogger,
  setLoggerEnabled,
} from '../middleware/log'
